<template>
  <div>
    <el-dialog
      title="创建揽收"
      :visible="visible"
      width="42%"
      :close-on-click-modal="false"
      @close="close"
    >
      <div class="content">
        <div class="left">
          <el-form
            label-width="100px"
            ref="form"
            :model="form"
            :rules="formRules"
          >
            <el-form-item label="重量" prop="weight">
              <el-input v-model="form.weight" placeholder="重量"></el-input>
            </el-form-item>
            <el-form-item label="运单号" prop="conveyNumber">
              <el-input
                v-model="form.conveyNumber"
                autofocus
                placeholder="运单号"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                v-loading.fullscreen="saveLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                type="primary"
                @click="save"
                :loading="saveLoading"
                :disabled="saveDisabled"
                >录入</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="middleDriver"></div>
        <div class="right">
          <p class="title">总计重量： {{ totalWeight }}kg</p>
          <div class="tableBox">
            <el-table
              height="250"
              :data="tableData"
              border
              style="width: 100%"
              :header-cell-style="{ textAlign: 'center' }"
            >
              <el-table-column
                prop="conveyNumber"
                label="运单号"
                width="200"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="weight"
                label="重量(kg)"
                align="center"
              ></el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    @click="remove(scope.$index)"
                    size="mini"
                    >移除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!--        <upload-excel-component :on-success="handleSuccess" />-->

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="close"
          :loading="submitLoading"
          :disabled="submitDisabled"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="submit"
          :loading="submitLoading"
          :disabled="submitDisabled"
          >确认提交</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible="tipVisible" width="30%" @close="closeTip">
      <span>
        该单号【{{
          form.conveyNumber
        }}】不是速卖通半托管单号,无法创建揽收该单号</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeTip">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
import Big from "big.js";
export default {
  name: "scanPackage",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        weight: undefined, //重量
        conveyNumber: undefined, //运单号
      },
      formRules: {
        weight: [
          { required: true, message: "请输入重量", trigger: "change" },
          { validator: this.checkWeight, trigger: "change" },
        ],
        conveyNumber: [
          { required: true, message: "请输入运单号", trigger: "change" },
          { validator: this.checkNumber, trigger: "change" },
        ],
      },
      saveDisabled: false,
      saveLoading: false,
      tableData: [], //录入的数据

      tipVisible: false, //消息提示
      submitLoading: false,
      submitDisabled: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    //校验重量为数字
    checkWeight(rule, value, callback) {
      if (isNaN(value)) {
        callback("请输入数字格式");
        return;
      }
      callback();
    },
    checkNumber(rule, value, callback) {
      if (
        this.tableData?.filter((ele) => ele.conveyNumber === value)?.length >= 1
      ) {
        callback("此运单号已存在！");
        return;
      }
      callback();
    },
    //链接websocket
    init() {
      this.openWebSocket(); //处理扫描的数据
      window.addEventListener("keyup", this.hanldeKeyup);
    },

    openWebSocket() {
      if (window.WebSocket) {
        this.ws = new WebSocket("ws://localhost:4397/");

        this.ws.onopen = (e) => {
          console.log("连接服务器成功");
          this.ws.send("start");
        };
        this.ws.onclose = (e) => {
          console.log("服务器关闭");
        };
        this.ws.onerror = () => {
          console.log("连接出错");
        };
        this.ws.onmessage = (e) => {
          // console.log(e.data);
          const dataStr = e.data;
          this.form.weight = dataStr;
        };
      }
    },
    hanldeKeyup(e) {
      // if (!this.formData.channelWeight || !this.formData.conveyNumber || !this.dialogVisible) return
      if (e.keyCode === 13) {
        //回车录入
        this.save();
      }
    },

    remove(index) {
      this.tableData.splice(index, 1);
    },

    close() {
      this.$emit("cancelVisible");
      window.removeEventListener("keyup", this.hanldeKeyup);
    },

    closeTip() {
      this.$refs.form.resetFields();
      this.tipVisible = false;
    },
    //录入
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          //1.调用录入接口成功之后进行push
          const API =
            Baseurl + "aliexpressSemiHostingCollection/judgeConveyNumber";
          const sendData = { ...this.form };
          ajaxPost(API, sendData)
            .then((res) => {
              const { code, data } = res.data;
              if (code === 200) {
                if (data) {
                  this.tableData.push(sendData);
                  this.$refs.form.resetFields();
                } else {
                  this.tipVisible = true;
                }
              } else {
                this.$message.error(data);
                this.$refs.form.resetFields();
              }
              this.saveDisabled = false;
              this.saveLoading = false;
            })
            .catch(() => {
              this.saveDisabled = false;
              this.saveLoading = false;
            });
        }
      });
    },

    submit() {
      if (this.tableData?.length < 1) {
        this.$message.error("录入后进行提交");
        return;
      }
      const API =
        Baseurl + "aliexpressSemiHostingCollection/scanCodeCreatePickupOrder";
      this.submitDisabled = true;
      this.submitLoading = true;
      const sendData = {
        estimated_weight: this.totalWeight,
        conveyNumberList: this.tableData?.map((ele) => ele.conveyNumber),
      };
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.$emit("submit", { flag: true, id: data });
            this.$message.success("提交成功");
          } else {
            this.$emit("submit", { flag: false, message: data });
          }
          this.submitDisabled = false;
          this.submitLoading = false;
        })
        .catch(() => {
          this.submitDisabled = false;
          this.submitLoading = false;
        });
    },
  },
  computed: {
    totalWeight() {
      return this.tableData
        ?.map((ele) => ele.weight)
        ?.filter((ele) => ele)
        ?.reduce((a, b) => {
          return Big(a).plus(Big(b));
        }, 0);
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  gap: 8px;

  .left {
    width: 350px;
    border-right: 1px solid #eeee;
    padding-right: 24px;
  }

  .right {
    width: 400px;
    .title {
      margin-bottom: 12px;
    }
  }
}
</style>
